namespace Matrix.Rebalancer {
    export class SummaryViewAllAccountColumns {
        static columnsKey = 'Rebalancer.SummaryViewAllAccount';
    }
}
